import React from 'react';

const Icon170OrientationConfiguration2ReclinerCorner = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <rect
      x="80.07"
      y="296.82"
      width="216.75"
      height="216.75"
      transform="translate(593.65 216.75) rotate(90)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="-54.42"
      y="379.07"
      width="216.75"
      height="52.25"
      transform="translate(459.15 351.25) rotate(90)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M94.57,80.07h202.25v216.75H80.07V94.57c0-8,6.5-14.5,14.5-14.5Z"
      transform="translate(376.9 0) rotate(90)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M27.83,38.08v41.99s0,216.75,0,216.75h52.25s0-216.75,0-216.75h206.49c5.66,0,10.26-4.59,10.26-10.26v-31.73c0-5.66-4.59-10.26-10.26-10.26H38.08c-5.66,0-10.26,4.59-10.26,10.26Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <g>
      <rect
        x="296.82"
        y="80.07"
        width="216.75"
        height="216.75"
        transform="translate(810.4 376.9) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M296.82,27.83h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9V27.83h0Z"
        transform="translate(810.4 107.9) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <g>
        <rect
          x="513.57"
          y="80.07"
          width="216.75"
          height="216.75"
          transform="translate(1243.89 376.9) rotate(-180)"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M739.5,27.83h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18V37.01c0-5.07,4.11-9.18,9.18-9.18Z"
          transform="translate(1502.49 324.65) rotate(-180)"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M513.57,27.83h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9V27.83h0Z"
          transform="translate(1243.89 107.9) rotate(-180)"
          fill="transparent"
          stroke="currentColor"
          strokeDasharray="15"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
        <path
          d="M513.57,296.82h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
          fill="transparent"
          stroke="currentColor"
          strokeDasharray="15"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
      </g>
    </g>
    <g>
      <rect
        x="80.07"
        y="513.57"
        width="216.75"
        height="216.75"
        transform="translate(-433.5 810.4) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M150.58,616.75h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        transform="translate(-588.92 913.57) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M-45.42,595.82h198.75c4.97,0,9,4.03,9,9v43.25H-54.42v-43.25c0-4.97,4.03-9,9-9Z"
        transform="translate(-568 675.9) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M223.57,595.82h198.75c4.97,0,9,4.03,9,9v43.25h-216.75v-43.25c0-4.97,4.03-9,9-9Z"
        transform="translate(944.89 299) rotate(90)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
    </g>
    <line
      x1="80.07"
      y1="296.82"
      x2="296.82"
      y2="296.82"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon170OrientationConfiguration2ReclinerCorner;
